
export enum SetPointTypeEnum {
    ValueComparison = 0,
    VariationPercent = 1,
    VariationAmount = 2,
    RpiMonitor = 3,
    TimeComparison = 4
}


